import { render, staticRenderFns } from "./delivery-fields.vue?vue&type=template&id=5b77a980&scoped=true"
import script from "./delivery-fields.vue?vue&type=script&lang=js"
export * from "./delivery-fields.vue?vue&type=script&lang=js"
import style0 from "./delivery-fields.vue?vue&type=style&index=0&id=5b77a980&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b77a980",
  null
  
)

export default component.exports